/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CheckoutActionIcon = createIcon("CheckoutActionIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M12 23H2.5A1.5 1.5 0 011 21.5v-19A1.5 1.5 0 012.5 1h19A1.5 1.5 0 0123 2.5V12m-6.5 11H23v-7m0 7L12 12",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
}, {
  "replaceColor": true
});